module.exports = __webpack_public_path__ + "static/media/权益八@2x.00b1eda2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_121/img/权益八@2x.png
// module id = 1143
// module chunks = 0